import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {HealthcareFacilitiesApi} from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import {HealthcareFacility} from '../HealthcareFacility.ts';

export function useDeleteHcfMutations() {
  const queryClient = useQueryClient();

  return useMutation<number, AppMedError, string>({
    mutationKey: [QueryKeys.healthcareFacilities],
    mutationFn: async (entityId: string) => {
      if (!entityId) 
        return 0;
      
      await HealthcareFacilitiesApi.deleteHealthcareFacilitiesById(entityId);

      queryClient.setQueryData<HealthcareFacility[]>([QueryKeys.healthcareFacilities], (prev) => {
        return prev ? prev.filter(el => el.id !== Number(entityId)) : [];
      });

      return Number(entityId);
    },
    onError: (error) => {
      console.error('Erreur dans la mutation :', error);
    }
  });
}

